<template lang="html">
  <div
    @mouseleave="show = false"
    v-click-outside="onClickOutside"
    class="picker-wrapper"
    :class="{ blackDiv: blackDiv }"
  >
    <!--
      <select v-model="$i18n.locale">
      <option value="sr">Srpski</option>
      <option value="en">English</option>
    </select> -->
    <div class="picker">
      <div @mouseover="show = true" @click="show = true" class="height-wrapper">
        <div class="picker-flag">
          <!-- <flag :squared="false" :iso="$i18n.locale" /> -->
          <img class="flag" :src="getFlag($i18n.locale)" alt="" />
        </div>
        <div class="picker-title">
          {{ $i18n.locale }}
        </div>
        <img
          class="dropdown-arrow"
          src="@/assets/icons/dropdownArrow.png"
          alt="dropdown arrow"
        />
      </div>
    </div>
    <div v-if="this.show" class="dropdown-wrapper">
      <div class="dropdown">
        <div
          @click="changeLocale(locale)"
          v-for="locale in $i18n.availableLocales"
          :key="locale"
          class="locale-option"
        >
          <div class="picker-flag">
            <!-- <flag :squared="false" :iso="getFlag(locale)" /> -->
            <img class="flag" :src="getFlag(locale)" alt="" />
          </div>
          <div class="picker-title">
            {{ locale }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocalePicker",
  mounted() {},
  props: {
    blackDiv: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    getFlag() {
      return locale => {
        switch (locale) {
          case "sr":
            return require("@/assets/icons/rs.svg");
          case "en":
            return require("@/assets/icons/gb.svg");
          default:
            return require("@/assets/icons/rs.svg");
        }
      };
    }
  },
  methods: {
    onClickOutside() {
      this.show = false;
    },
    changeLocale(locale) {
      this.$i18n.locale = locale;
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.picker-wrapper {
  height: 100%;
  display: flex;
  position: relative;

  .flag {
    height: 19px;
    width: 26px;
    margin-right: 5px;
  }

  .dropdown-wrapper {
    padding: 20px;
    padding-top: 40px;
    padding-right: 0px;
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 3;
  }
  .dropdown {
    background-color: white;
    padding: 10px;
    right: 0px;
    top: 100%;
    border: 1px solid #ddd;

    .locale-option {
      display: flex;
      align-items: center;
      cursor: pointer;

      .picker-title {
        // margin-top: 5px;
        color: $text-color;
        margin-right: 0px;
      }
    }
    .locale-option:hover .picker-title {
      color: $text-hover-color;
    }
  }
}
.picker {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .height-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.picker-flag span {
  border-radius: 3px;
  margin-right: 5px;
}
.picker-title {
  margin-right: 5px;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 21px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  transition-duration: 0.2s;
  color: $text-color;
}
.picker:hover .picker-title {
  color: $text-hover-color;
}
.small-nav-wrapper {
  .picker-wrapper {
    margin-bottom: 200px;
  }
  .dropdown-wrapper {
    padding: 0px;
    position: absolute;
    top: 50px;
    left: 0px;
    z-index: 3;
    width: 85px;
  }
  .dropdown-arrow {
    filter: brightness(5);
  }
  .height-wrapper .picker-title {
    color: $text-color;
  }
}
.picker-wrapper.blackDiv {
  margin-bottom: 0 !important;
  min-height: 120px !important;
  background-color: #3f3f41;
  color: #ffffff;
  .dropdown-wrapper {
    top: 30px;
    left: 0px;
  }
  .dropdown {
    background-color: white;
    background-color: #3f3f41;

    padding: 0px;
    right: 0px;
    top: 10%;
    border: transparent;
    .picker-title {
      color: #ffffff !important;
    }
  }
}
</style>
